var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ym-mk-banner"},[_c('img',{staticClass:"banner",attrs:{"src":_vm.src,"alt":"banner 图"}}),(_vm.hint !== '')?_c('span',{staticClass:"hint"},[_vm._v("\n    "+_vm._s(_vm.hint)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }